import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import useDebounce from "../../../hooks/useDebounce";
import { useCheckout } from "../../providers/CheckoutProvider";

export const AutomaticAddressLookup = (props) => {
  console.log("[AUTO] Props", props);
  const { field, form } = props;
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const debouncedQuery = useDebounce(field.value, 500);
  const [selectedOption, setSelectedOption] = useState(null);
  const { apiClient } = useCheckout();

  console.log("Automatic props", field);

  useEffect(() => {
    let active = true;

    if (!open || field.value.length == 0) {
      setLoading(false);
      setOptions([]);
      return;
    }

    (async () => {
      setLoading(true);
      const result = await apiClient.autocompleteAddress(debouncedQuery);

      if (active) {
        setLoading(false);
        setOptions(result.suggestions);
      }
    })();

    return () => {
      active = false;
    };
  }, [debouncedQuery]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const handleSelectAddress = async (event, address) => {
    // Some services return the address at once:
    if (address.address) {
      //const { userAddress: address } = address.address;
      const userAddress = address.address;
      console.log("Handle select address", userAddress);
      await form.setFieldValue("address", userAddress.address1);
      await form.setFieldValue("address2", userAddress.address2);
      await form.setFieldValue("postalCode", userAddress.postalCode);
      await form.setFieldValue("city", userAddress.city);
      await form.setFieldValue("state", userAddress.state);
      await form.setFieldValue("verifiedAddress", true);
      return;
    }

    const result = await apiClient.resolveAddressById(address.id);

    if (!result.error) {
      await form.setFieldValue("address", result.address.address1);
      await form.setFieldValue("address2", result.address.address2);
      await form.setFieldValue("postalCode", result.address.postalCode);
      await form.setFieldValue("city", result.address.city);
      await form.setFieldValue("state", result.address.state);
      await form.setFieldValue("verifiedAddress", true);
    } else {
      await form.setFieldValue("address", "");
      await form.setFieldError("address", t("Error resolving address"));
    }
  };

  return (
    <Autocomplete
      freeSolo
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={(e) => {
        setOpen(false);
        field.onBlur(e);
      }}
      getOptionSelected={(option, value) =>
        typeof option == "object" && option.id === value.id
      }
      getOptionLabel={(option) =>
        typeof option == "string" ? option : option.suggestion
      }
      options={options}
      loading={open && loading}
      value={selectedOption}
      filterOptions={(x) => x}
      includeInputInList
      disableClearable
      onChange={handleSelectAddress}
      onInputChange={(event, newValue) => {
        console.log("[AUTO] Input change event", event);
        // Seem like this is initialized at null?
        if (event !== null) {
          form.setFieldValue("address", newValue);
          form.setFieldTouched("address");
        }
      }}
      inputValue={field.value}
      renderInput={(params) => {
        console.log(
          "[AUTO] Render props",
          params,
          form,
          form.errors.address,
          form.touched.address,
        );
        return (
          <TextField
            {...params}
            label={t("Address")}
            margin="normal"
            error={!!form.errors.address && form.touched.address}
            helperText={form.errors.address}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        );
      }}
    />
  );
};
